(() => {
  function init(root) {
    root.querySelectorAll('.main-product-inner-tabination:not([data-tabs-ready])').forEach(section => {
      const list = section.querySelector('.tabs-product');
      const tabs = [...list.querySelectorAll('a[href^="#tab-"]')];
      const panels = tabs.map(tab => section.querySelector(tab.getAttribute('href')));
      if (!tabs.length || panels.some(panel => !panel)) return;
      list.setAttribute('role', 'tablist');
      function select(index, focus = false) {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[i].hidden = !active;
          panels[i].classList.toggle('active', active);
        });
        if (focus) tabs[index].focus();
      }
      tabs.forEach((tab, i) => {
        tab.parentElement.setAttribute('role', 'presentation');
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[i].id);
        panels[i].setAttribute('role', 'tabpanel');
        tab.addEventListener('click', event => { event.preventDefault(); select(i); });
        tab.addEventListener('keydown', event => {
          const keys = {ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1};
          if (Object.hasOwn(keys, event.key)) { event.preventDefault(); select(keys[event.key], true); }
        });
      });
      section.dataset.tabsReady = 'true';
      const linked = tabs.findIndex(tab => tab.hash === window.location.hash);
      select(linked >= 0 ? linked : 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
